

//etilos
import './verReporte.css'

import iconVerReporte from './IconVerReporte.svg'
import { Link } from 'react-router-dom'

export const VerReporte = () => {

    // const exportarPlanilla = () => {
    //     console.log('Ver Reporte')
    // }

    return (
        <Link
            to='/dashboard/ventas'
            className='btn p-btn-ver-reporte flex'>
            <img src={iconVerReporte} alt="Ver Reporte" />
            <span className='ms-2'>Ver Reporte</span>
        </Link>
    )
}
